import { observer } from "mobx-react-lite";
import React, { Component } from "react";
import styled from "styled-components";
import { MenuCard } from "../menu/MenuCard";
import { UiConstants } from "../../data/UiConstants";
import { WorkshopListView } from "./ManagementListView";
import { LogoutButton } from "../auth/LogoutButton";
import { userStore } from "../../stores/UserStore";
import { managementStore } from "../../stores/ManagementStore";
import { WorkshopDetailView } from "./WorkshopDetailView";
import { useTranslation } from "react-i18next";
import { openProductionEditor } from "./WorkshopHelper";
import { useHistory } from "react-router";
import { EditorNotifications } from "../editor/EditorNotifications";
import { managementClient } from "../../communication/ManagementClient";
import { LanguageSwitcher } from "../editor/LanguageSwitcher";
import { BsTranslate } from "react-icons/bs";
import { routes } from "../../data/routes";
import { NavigateTo } from "../shared/NavigateTo";
import { LoadingHeaderRightManagement } from "../editor/Header";
const ManagementWindow = styled.div.withConfig({
  displayName: "WorkshopManagement__ManagementWindow",
  componentId: "sc-1ngz156-0"
})(["display:grid;grid-template-columns:0.7fr 3fr;max-width:870px;height:99vh;"]);
const MainMenuWindow = styled(MenuCard).withConfig({
  displayName: "WorkshopManagement__MainMenuWindow",
  componentId: "sc-1ngz156-1"
})(["grid-column-start:1;display:grid;grid-template-rows:auto auto 1fr auto;row-gap:5px;background:", ";"], UiConstants.COLOR_MENU_BACKGROUND);
const ContentWindow = styled(MenuCard).withConfig({
  displayName: "WorkshopManagement__ContentWindow",
  componentId: "sc-1ngz156-2"
})(["grid-column-start:2;"]);
const ButtonGroup = styled.div.withConfig({
  displayName: "WorkshopManagement__ButtonGroup",
  componentId: "sc-1ngz156-3"
})(["grid-auto-rows:40px;display:grid;row-gap:5px;"]);

class ManagementClientConnector extends Component {
  componentDidMount() {
    managementClient.connectManagement();
  }

  componentWillUnmount() {
    managementClient.disconnect();
  }

  render() {
    return null;
  }

}

export const WorkshopManagement = observer(() => {
  var _managementStore$sess;

  const {
    t
  } = useTranslation();
  const history = useHistory();

  if (!userStore.isLoggedIn) {
    return /*#__PURE__*/React.createElement(NavigateTo, {
      to: routes.home
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ManagementClientConnector, null), /*#__PURE__*/React.createElement(EditorNotifications, {
    isConnectedAndReadyCallback: () => managementStore.isConnectedAndReady,
    AdditionalConnectionStatusDisplay: () => null,
    LoadingHeader: LoadingHeaderRightManagement
  }), managementStore.isInitialized && /*#__PURE__*/React.createElement(ManagementWindow, null, /*#__PURE__*/React.createElement(MainMenuWindow, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BsTranslate, null), " ", t("editor.language")), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(LanguageSwitcher, null)), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(ButtonGroup, null, userStore.mayOpenMainGameEditor && /*#__PURE__*/React.createElement("button", {
    onClick: () => openProductionEditor(history)
  }, t("management.open_editor")), /*#__PURE__*/React.createElement(LogoutButton, null))), userStore.mayEditAllWorkshops && /*#__PURE__*/React.createElement(ContentWindow, null, /*#__PURE__*/React.createElement(WorkshopListView, null)), !userStore.mayEditAllWorkshops && /*#__PURE__*/React.createElement(ContentWindow, null, managementStore.sessionWorkshop && /*#__PURE__*/React.createElement(WorkshopDetailView, {
    editItem: (_managementStore$sess = managementStore.sessionWorkshop) === null || _managementStore$sess === void 0 ? void 0 : _managementStore$sess.$modelId
  }), !managementStore.sessionWorkshop && /*#__PURE__*/React.createElement("div", null, t("editor.error_workshop_does_not_exist")))), !managementStore.isInitialized && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, t("management.loading_message")), /*#__PURE__*/React.createElement(LogoutButton, null)));
});